module.exports = __webpack_public_path__ + "static/media/downloadFullLogHover.20e95048.png";